import { Navigate, Outlet, useLocation } from "react-router-dom";
import {
  getSafeRedirectTarget,
  isAuthenticated,
  needsPasswordChange,
} from "./authUtils";

const ALLOWED_AUTHENTICATED_PUBLIC_PATHS = ["/change-password"];

/**
 * Guest-only routes (login, register, etc.).
 * Authenticated users are sent to their redirect target or the dashboard,
 * except when a forced password change is required.
 */
export default function PublicRoute() {
  const location = useLocation();

  if (!isAuthenticated()) {
    return <Outlet />;
  }

  if (
    needsPasswordChange() &&
    ALLOWED_AUTHENTICATED_PUBLIC_PATHS.includes(location.pathname)
  ) {
    return <Outlet />;
  }

  if (needsPasswordChange()) {
    return <Navigate to="/change-password" replace />;
  }

  const redirectTarget =
    getSafeRedirectTarget(location.search) || "/dashboard";

  return <Navigate to={redirectTarget} replace />;
}
